import { useState } from "react";
import axios from "axios";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

// Shown right after a member checks in — lets the table also check in the
// household members on that member's record (they have no PIN of their own).
export default function HouseholdCheckinPrompt({ memberId, household, onDone }) {
  const [sel, setSel] = useState(() => new Set(household.map((_, i) => i)));
  const [busy, setBusy] = useState(false);
  const toggle = (i) => setSel((s) => { const n = new Set(s); n.has(i) ? n.delete(i) : n.add(i); return n; });
  const submit = async () => {
    const names = household.filter((_, i) => sel.has(i)).map((h) => h.name);
    if (names.length === 0) return onDone(0);
    setBusy(true);
    try { const r = await pub.post("/checkin/household", { member_id: memberId, names }); onDone(r.data.count || 0); }
    catch (e) { onDone(0); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="household-prompt" className="mt-1">
      <div className="text-center mb-3">
        <div className="font-zilla text-xl font-semibold">Anyone with you today?</div>
        <div className="text-ink/55 text-[14px]">Tap the household members who are here.</div>
      </div>
      <div className="space-y-2 mb-3">
        {household.map((h, i) => (
          <button key={i} data-testid={`household-opt-${i}`} onClick={() => toggle(i)}
            className={`w-full flex items-center gap-3 text-left px-3 py-2.5 rounded-lg border min-h-[48px] ${sel.has(i) ? "bg-olive/20 border-olive/50" : "bg-cream border-ink/20"}`}>
            <span className={`w-5 h-5 rounded flex items-center justify-center shrink-0 border text-[13px] ${sel.has(i) ? "bg-olive border-olive text-ink" : "border-ink/30"}`}>{sel.has(i) ? "✓" : ""}</span>
            <span className="font-semibold text-[15px]">{h.name}</span>
            {h.relation ? <span className="text-ink/50 text-[13px]">{h.relation}</span> : null}
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <button data-testid="household-submit" disabled={busy} onClick={submit} className="flex-1 bg-dark-olive text-cream rounded-xl px-4 py-3 min-h-[52px] text-[15px] font-semibold disabled:opacity-50">{busy ? "Checking in…" : "Check in selected"}</button>
        <button data-testid="household-skip" onClick={() => onDone(0)} className="border border-ink/25 rounded-xl px-4 py-3 min-h-[52px] text-[15px] font-semibold">Skip</button>
      </div>
    </div>
  );
}
